var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHomePage = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.69785 12.155H15.6979V18.155H17.6979V10.155H18.2871L12.1979 4.67028L6.10858 10.155H6.69785V18.155H8.69785V12.155ZM3.49785 11.655C3.03785 11.655 2.82785 11.085 3.16785 10.785L11.5279 3.255C11.9079 2.915 12.4879 2.915 12.8679 3.255L21.2279 10.785C21.5779 11.085 21.3579 11.655 20.8979 11.655H19.1979V18.655C19.1979 19.205 18.7479 19.655 18.1979 19.655H15.1979C14.6479 19.655 14.1979 19.205 14.1979 18.655V13.655H10.1979V18.655C10.1979 19.205 9.74785 19.655 9.19785 19.655H6.19785C5.64785 19.655 5.19785 19.205 5.19785 18.655V11.655H3.49785Z",
  fill: "#FF8B22"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHomePage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/home-page.97ba0c6c44c7edc3f14b876599bc56d7.svg";